export default __webpack_public_path__ + "static/media/Welcome.88384eb5.mp4";